<template>
  <div class="flex px-3 shadow-md whitespace-nowrap bg-primary border-primary text-white" style="border-radius: 2rem">
    <span v-if="!isLogin" />
    <span
      v-else-if="
        problemDescriptionPresenter.problemDescription.value.isSolved || nested.judgeStatus.value == 'ACCEPTED'
      "
      class="material-icons text-2xl my-auto notranslate text-white dark:text-dark-text"
      :title="$t('message.isSolved')"
    >
      check_circle
    </span>
    <span
      v-else
      class="material-icons text-2xl my-auto rounded-full text-white dark:text-dark-text"
      :title="$t('message.isNotSolved')"
    >
      remove_circle_outline
    </span>
    <span
      v-if="arenaPresenter.arenaId.value != ''"
      class="text-xl inline-block px-3 my-auto whitespace-no-wrap text-white dark:text-dark-text"
      style="border-radius: 1rem"
      :title="$t('message.problemId')"
    >
      {{ arenaPresenter.arenaId.value }} - {{ arenaPresenter.arenaProblemId.value }} -
      {{ problemId }}
    </span>
    <span
      v-else
      class="text-xl inline-block px-3 my-auto whitespace-no-wrap text-white dark:text-dark-text"
      :class="{
        'py-1': !isLogin
      }"
      style="border-radius: 1rem"
      :title="$t('message.problemId')"
    >
      {{ problemId }}
    </span>
    <div v-if="!isLogin" />
    <div v-else style="margin-top: 3px; margin-bottom: 1px">
      <button
        v-if="nested.isBookmark.value"
        class="focus:outline-none material-icons"
        :title="$t('message.bookmarked')"
        @click="deleteBookmark()"
      >
        <span class="material-icons text-2xl" style="color: #f7c327"> bookmark </span>
      </button>
      <button
        v-else
        class="focus:outline-none material-icons"
        :title="$t('message.addBookmark')"
        @click="postBookmark()"
      >
        <span class="material-icons text-2xl text-white dark:text-dark-text"> bookmark_border </span>
      </button>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, ref, watch } from 'vue'

import { useArenaPresenter } from '@/presentation/composables/arena/useArenaPresenter'
import { useAuthStatePresenter } from '@/presentation/composables/auth/useAuthStatePresenter'
import { useBookmarkPresenter } from '@/presentation/composables/bookmark/useBookmarkPresenter'
import { useJudgeDetailPresenter } from '@/presentation/composables/judge/useJudgeDetailPresenter'
import { useProblemDescriptionPresenter } from '@/presentation/composables/problem/useProblemDescriptionPresenter'
import { useProblemStatePresenter } from '@/presentation/composables/problem/useProblemStatePresenter'

export default defineComponent({
  setup(props, ctx) {
    const bookmarkPresenter = useBookmarkPresenter()
    const { problemId } = useProblemStatePresenter()
    const problemDescriptionPresenter = useProblemDescriptionPresenter()
    const { user, isLogin } = useAuthStatePresenter()
    const arenaPresenter = useArenaPresenter()
    const { judgeDetail } = useJudgeDetailPresenter()

    const judgeCase = computed(() => (judgeDetail.value ? judgeDetail.value.submissionRecord : null))

    const judgeStatus = computed(() => (judgeCase.value ? judgeCase.value.status : ''))

    const isBookmark = ref(false)

    const postBookmark = () => {
      if (isLogin.value) {
        bookmarkPresenter.postBookmark(problemId.value, user.value.id)
        isBookmark.value = true
        setTimeout(() => {
          bookmarkPresenter.getBookmark(user.value.id)
        }, 500)
      }
    }
    const deleteBookmark = () => {
      if (isLogin.value) {
        bookmarkPresenter.deleteBookmark(problemId.value, user.value.id)
        isBookmark.value = false
        setTimeout(() => {
          bookmarkPresenter.getBookmark(user.value.id)
        }, 500)
      }
    }

    const checkBookmark = () => {
      if (isLogin.value) {
        for (let i = 0; i < bookmarkPresenter.bookmark.value.problems.length; i++) {
          if (bookmarkPresenter.bookmark.value.problems[i].id == problemId.value) {
            isBookmark.value = true
            return
          }
        }
      }
      isBookmark.value = false
    }

    watch(
      () => problemDescriptionPresenter.problemDescription.value.html,
      () => {
        checkBookmark()
      }
    )

    watch(
      () => bookmarkPresenter.bookmark.value.problems.length,
      () => {
        if (isLogin.value) {
          checkBookmark()
        }
      }
    )

    watch(
      () => isLogin.value,
      () => {
        if (isLogin.value) {
          checkBookmark()
        }
      },
      { immediate: true }
    )

    return {
      nested: { judgeStatus, isBookmark },
      problemDescriptionPresenter,
      postBookmark,
      deleteBookmark,
      arenaPresenter,
      user,
      problemId,
      isLogin
    }
  }
})
</script>

<style lang="postcss" scoped></style>
